// extracted by mini-css-extract-plugin
module.exports = {"graphHeight":"StatsGraph_graphHeight__A_H8f","calendarBox":"StatsGraph_calendarBox__3IYXX","dateText":"StatsGraph_dateText__3nL1G"};